import { ActivatedRoute, Params, Router } from '@angular/router';
import { forIn, isEmpty } from 'lodash';
import { FilterFieldValue } from '../covance-filter.models';
import { Subject, Observable } from 'rxjs';

export abstract class CovanceFilterBaseType {

    public changeDetector: Observable<boolean>;

    protected changes = new Subject<boolean>();

    constructor(protected router: Router, protected route: ActivatedRoute) {
        this.changeDetector = this.changes.asObservable();
    }

    public abstract isMatch(fieldVal: FilterFieldValue, value: any): boolean;

    public abstract serializeValue(value: any): string;

    public setItems(fieldVal: FilterFieldValue, entities: any[]) { }
    
    public setValue(fieldVal: FilterFieldValue) {
        fieldVal.value = fieldVal.queryParamValue;
    }

    public setQueryParamValue(fieldVal: FilterFieldValue) {
        fieldVal.queryParamValue = fieldVal.value ? fieldVal.value.toString() : null;
    }

    public onFieldChange(fieldVal: FilterFieldValue) {
        if (fieldVal.def.queryParam) {
            const queryParams: Params = {};
            forIn(this.route.snapshot.queryParams, (value: string, key: string) => {
                if (key !== fieldVal.def.queryParam) {
                    queryParams[key] = value;
                }
            });

            if (!isEmpty(fieldVal.queryParamValue)) {
                queryParams[fieldVal.def.queryParam] = fieldVal.queryParamValue;
            }

            this.router.navigate([], {
                queryParams: queryParams,
                relativeTo: this.route
            });
        }

        if (fieldVal.def.onChange) {
            fieldVal.def.onChange(fieldVal);
        }
    }

    protected assertExistingEntityProperty(entity: { [key: string]: any }, key: string) {
        if (entity[key] == null) {
            const typeName = entity.constructor.name
                ? entity.constructor.name
                : 'entity';

            throw new Error(`The '${key}' property of ${typeName} is null/undefined. Probably should be filled on the server-side`);
        }
    }
}